export default defineNuxtPlugin(() => {
  const url = new URL(location.href)
  if (url.searchParams.has("close")) {
    window.close()
  }
})
